export default __webpack_public_path__ + "static/media/Twin house.f1143824.jpg";